import { api } from "./client";
import { getActiveLang } from "../i18n";

export type ShippingService =
  | "parcel"
  | "express"
  | "intl-standard"
  | "intl-express";

export type ShippingOption = {
  service: ShippingService;
  label: string;
  amount: string; // decimal string, AUD
};

export type QuoteInput = {
  deckKeys: string[]; // 1–2 unique deck keys; two = bundle (free standard shipping)
  country: string; // ISO-2
  postcode?: string;
};

export type DeckCheckoutInput = {
  deckKeys: string[]; // 1–2 unique deck keys; two = bundle
  service: ShippingService;
  fullName: string;
  email: string;
  phone: string;
  country: string;
  line1: string;
  line2?: string;
  city: string;
  state?: string;
  postcode?: string;
  notes?: string;
  /** App path Stripe returns to, so the confirmation shows on the page the
   *  buyer left. Path-only — the backend rejects anything off-site. */
  returnPath?: string;
};

export async function getShippingQuotes(input: QuoteInput): Promise<ShippingOption[]> {
  const { data } = await api.post<{ shippingOptions: ShippingOption[] }>(
    "/api/shop/quote/",
    input,
  );
  return data.shippingOptions;
}

export async function createDeckCheckout(
  input: DeckCheckoutInput,
): Promise<{ url: string | null }> {
  const language = getActiveLang();
  const { data } = await api.post<{ url: string | null }>(
    "/api/shop/checkout/",
    { ...input, language },
  );
  return data;
}
